import { SINGLE_NUMERIC, SINGLE_PATTERN } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const lpf: EffectEntry = {
  kind: 'lpf',
  category: 'effect',
  family: 'filter',
  doc: 'low-pass cutoff in Hz (80 muddy, 400 bass, 1.2k warm, 8k bright)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('lpf', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('lpf', 'fromAst'),
};

export const lpq: EffectEntry = {
  kind: 'lpq',
  category: 'effect',
  family: 'filter',
  doc: 'low-pass resonance (0.5 neutral, 6 vocal, 18 acid squelch)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('lpq', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('lpq', 'fromAst'),
};

export const hpf: EffectEntry = {
  kind: 'hpf',
  category: 'effect',
  family: 'filter',
  doc: 'high-pass cutoff in Hz (removes rumble below it)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('hpf', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('hpf', 'fromAst'),
};

export const hpq: EffectEntry = {
  kind: 'hpq',
  category: 'effect',
  family: 'filter',
  doc: 'high-pass resonance',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('hpq', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('hpq', 'fromAst'),
};

export const bpf: EffectEntry = {
  kind: 'bpf',
  category: 'effect',
  family: 'filter',
  doc: 'band-pass center frequency in Hz',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('bpf', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('bpf', 'fromAst'),
};

export const bpq: EffectEntry = {
  kind: 'bpq',
  category: 'effect',
  family: 'filter',
  doc: 'band-pass Q',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('bpq', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('bpq', 'fromAst'),
};

export const djf: EffectEntry = {
  kind: 'djf',
  category: 'effect',
  family: 'filter',
  doc: 'single-knob DJ filter (0.5 flat, <0.5 lowpass, >0.5 highpass)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('djf', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('djf', 'fromAst'),
};

export const hcut: EffectEntry = {
  kind: 'hcut',
  category: 'effect',
  family: 'filter',
  doc: 'high-cut above this Hz (alternative lpf)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('hcut', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('hcut', 'fromAst'),
};

export const lcut: EffectEntry = {
  kind: 'lcut',
  category: 'effect',
  family: 'filter',
  doc: 'low-cut below this Hz (alternative hpf)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('lcut', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('lcut', 'fromAst'),
};

export const vowel: EffectEntry = {
  kind: 'vowel',
  category: 'effect',
  family: 'filter',
  doc: 'formant filter, pattern of vowels: "a e i o u"',
  args: SINGLE_PATTERN,
  toCode: () => STUB_NOT_IMPLEMENTED('vowel', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('vowel', 'fromAst'),
};
